export class ExamType {

     extypId: number;
    cutypCode: string;
    extypCode: string;
    extypCodeInternational: string;
    extypCodeLocal: string;
    extypDesc: string;
    extypDescEn: string;
    sortIndex: number;
    staRecCode: string;
}